<template>
  <div class="uni-template">
    <!-- header -->
    <Header v-if="role == 'student'" />
    <!-- 教师 -->
    <HeaderTeacher v-else />

    <!-- container -->
    <div class="container-box">
      <!-- menu -->
      <Menu v-if="isShowMenu" />

      <!-- content -->
      <div
        class="content uni-scroll-container"
        ref="ulScroll1"
        v-loading="isFullLoading"
      >
        <div class="main-content" id="main-content">

          <!-- <router-view @scrollTopO="scrollTopO" /> -->

          <keep-alive :include="keepAliveViews">
            <router-view @scrollTopO="scrollTopO" />
          </keep-alive>

          <div class="uni-copy-right" v-if="isRouterName !== 'classRecordData'">
            <i></i><span @click="isUrl(3)">渝公网安备 50010602502220 号</span>，
            技术支持：<span @click="isUrl(1)">重庆卓培教育科技有限公司</span
            >，<span @click="isUrl(2)">渝ICP备18010001号-3</span>
          </div>
        </div>

        <!-- 侧边栏 -->
        <router-view name="sideBanner" />
      </div>
    </div>
    <DialogFace v-if="isDialogFace" @isShowFace="isShowFace" />
<!--    <Face-->
<!--      ref="face"-->
<!--      v-if="isFace"-->
<!--      @isValidationFace="isValidationFace"-->
<!--      @isRouter="isRouter"-->
<!--    />-->
    <faceVideo
      v-if="false"
      :isTest="true"
      :equipment="true"
      @isRouter="isRouterVideo"
      @forcedSubmit="forcedSubmit"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeaderTeacher from "./headerTeacher";
import Header from "./header";
import Menu from "./menu";
import DialogFace from "./templateModule/dialogFace";
import Face from "@/components/face";
import faceVideo from "@/components/faceVideo";
import { getStore, setStore } from "@/utils/localStorage";
import { loginOut } from "@/api/login";
export default {
  name: "Template",
  provide () {
    return {
      scrollTopO: this.scrollTopO,
    }
  },
  data() {
    return {
      isFace: false,
      isDialogFace: false,
      isFaceVideo: false,
      userInfo: JSON.parse(getStore("userInfo")),
      isRouterName: "",
      userdata: "",
      keepAliveViews: ['RealTest'],
      isShowMenu: true,  //显示导航栏 这里用于刷新
    };
  },
  watch: {
    adultType: {
      handler(v) {
        this.reload();
      },
      // deep: true,
      // immediate: true,
    },
  },
  components: {
    HeaderTeacher,
    Header,
    Menu,
    DialogFace,
    // Face,
    faceVideo,
  },
  computed: {
    ...mapState("common", {
      isFullLoading: (state) => state.isFullLoading,
      enterConfirm: state => state.enterConfirm,   //是否确认信息
      firstLoginVerify: state => state.firstLoginVerify,  //是否第一次登录
    }),
    ...mapState("permission", {
      _ENTRANCETYPE: (state) => state._ENTRANCETYPE,  //成教/自考
    }),
    adultType(){
      return this.$store.state.permission.adultType;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.isRouterName = to.name;
      vm.isOpenId();
    });
  },
  created() {
    this.role = this.userInfo.user_type;
    // 主题色
    if (this.userInfo.topic == 1) {
      document.body.className = "theme-blue";
    } else {
      document.body.className = "theme-red";
    }
    if (this.userInfo.first_login_verify === 0) this.isShowFace();

    if(this._ENTRANCETYPE === 'adult'){
      if(this.enterConfirm == 0){
        // this.$router.push({
        //   path: "/confirmInfo",
        //   query: {
            
        //   },
        // });
        // 重新登录
        window.sessionStorage.clear();
        window.localStorage.clear();
        // this.$store.dispatch('permission/setIsGenerateRoutes', true);
        this.$store.dispatch('permission/logOut');
        // Cookies.remove('token');
        // this.$message.success('请重新登录');
        this.$router.replace("/Login");
      }
      // else if(this.firstLoginVerify == 0){
      //   this.$router.push({
      //     path: "/verify",
      //     query: {
      //       classId: id,
      //     },
      //   });
      // }
    }

  },
  methods: {
    // 刷新导航栏
    async reload () {
      this.isShowMenu = false
      await this.$nextTick();
      this.isShowMenu = true
    },
    scrollTopO() {
      setTimeout(() => {
        this.$refs.ulScroll1.scrollTop = 0;
      }, 100);
    },
    // 关闭人脸识别
    isRouter() {
      this.$router.replace("/changePwd");
      this.isFace = false;
    },
    isRouterVideo() {
      this.isFaceVideo = false;
      const isOpen = this.userInfo;
      console.log(isOpen);
      isOpen.flag = false;
      setStore("userInfo", isOpen);
    },
    // 切换设备3次不过，返回登陆页
    forcedSubmit() {
      loginOut(null).then(() => {
        // 清除缓存
        window.sessionStorage.clear();
        window.localStorage.clear();
        // Cookies.remove('token');
        document.body.className = "";
        this.$router.replace("/");
      });
    },
    isValidationFace() {
      this.$message({
        message: "请进行人脸验证",
        type: "warning",
      });
    },
    isShowFace() {
      this.isDialogFace = false;
      this.isFace = true;
    },
    isOpenId() {
      const isOpen = getStore("userInfo");
      if (isOpen) {
        let isOpne = JSON.parse(isOpen);
        if (isOpne.loginType === "xuesheng" && isOpne.isPersonVerify) {
          this.isDialogFace = true;
          return;
        }
        if (isOpne.flag) {
          this.isFaceVideo = true;
          return;
        }
        if (isOpne.loginType !== "xuesheng" && isOpne.isFirst) {
          this.$router.replace("/changePwd");
          return;
        }
        if (
          isOpne.loginType === "xuesheng" &&
          !isOpne.isPersonVerify &&
          isOpne.isFirst
        ) {
          this.$router.replace("/changePwd");
        }
      }
    },
    isUrl(type) {
      const urlText =
        type === 1
          ? "https://www.zpjykj.com/"
          : "https://beian.miit.gov.cn/#/Integrated/index";
      window.open(urlText);
    },
  },
};
</script>

<style lang="scss" scoped>
.uni-template {
  width: 100%;
  height: 100%;

  .container-box {
    display: flex;
    .content {
      flex: 1;
      display: flex;
      .main-content {
        flex: 1;
        width: calc(100vw - 250px);
      }
    }
  }

  .uni-scroll-container {
    height: $mainH;
    overflow-y: auto;
    // overflow-x: hidden;
    background-color: #eaeef7;
  }

  @media screen and (min-width: 1360px) {
    .uni-scroll-container {
      overflow-x: hidden;
    }
  }

  .uni-copy-right {
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 12px;
    color: rgba(127, 127, 127, 1);

    i {
      width: 10px;
      height: 10px;
      background: url("~@/assets/images/securityIcon.jpg") no-repeat;
      background-size: 100% 100%;
      display: inline-block;
      margin-right: 5px;
    }
  }
  .uni-copy-right span {
    cursor: pointer;
    &:hover {
      @include fontColor("primary");
    }
  }
}
</style>
